import { Resource } from '../../../common/resource.model';
import { Entidade } from '../entidade/entidade';

export class ConfiguracaoLogin extends Resource {
    informacao: string;
    entidade: Entidade;
}
